import { Column } from './column';

export class Filter {
    column: Array<Column>;
}




// WEBPACK FOOTER //
// ./src/app/class/filter.ts